import type { ThemeComponentType } from '../types';

export const Accordion: ThemeComponentType = {
  defaultProps: {
    chevronPosition: 'left',
    variant: 'filled',
  },
  styles: (theme, { variant, chevronPosition }) => ({
    item: {
      borderColor: variant === 'contained' ? theme.colors.gray[1] : undefined,
      '&[data-active]': {
        backgroundColor: 'transparent',
      },
    },
    control: {
      ':hover': {
        backgroundColor: 'transparent',
      },
    },
    chevron: {
      marginRight: theme.other.spacing(0.5),
      svg: {
        width: 32,
        height: 32,
      },
      transform: chevronPosition === 'right' ? undefined : 'rotate(-90deg)',
      '&[data-rotate]': {
        transform: chevronPosition === 'right' ? undefined : 'rotate(0deg)',
      },
    },
    label: {
      fontSize: theme.fontSizes.xl,
      fontWeight: 600,
    },
  }),
};
